<template>
    <div>
        <treeselect
            v-if="mode==='tree'"
            v-model="data"
            :multiple="multiple"
            :valueFormat="idOnly ? 'id' : 'object'"
            :placeholder="placeholder"
            :tab-index="parseInt(tabindex)"
            :normalizer="normalizer"
            :disable-branch-nodes="true"
            :options="teamStatic"
        />
        <b-input-group v-else>
            <b-form-select v-model="data" :size="size" :disabled="disabled" :tabindex="tabindex" :state="state">
                <option
                    :selected="team == data"
                    v-for="(team, teamIndex) in team()"
                    :key="teamIndex"
                    :value="idOnly ? team._id : team"
                >{{ team.firstName }} {{ team.lastName }}
                </option>
            </b-form-select>
        </b-input-group>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';


export default {
    props: {
        value: null,
        params: null,
        size: null,
        mode: null,
        nullUser: null,
        state: null,
        placeholder: { type: String, default: 'Select' },
        idOnly: Boolean,
        multiple: Boolean,
        disabled: Boolean,
        tabindex: { type: [String, Number], default: 0 }
    },
    components: {
        Treeselect
    },
    data() {
        return {
            company: { firstName: this.$t('Company'), lastName: '', _id: null, avatar: 's' }
        }
    },
    computed: {
        ...mapState('my-team', { isTeamLoading: 'isFindPending' }),
        ...mapGetters('my-team', { findTeamInStore: 'find' }),
        teamStatic() {
            let data = this.findTeamInStore(this.params).data;
            if (this.nullUser)
                data.push(this.company);
            return data;
        },
        data: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
                this.$emit('change', value)
            }
        },
    },
    methods: {
        normalizer(item) {
            item.id = item._id;
            item.label = item.firstName + ' ' + item.lastName;
            return item;
        },
        team() {
            let data = this.findTeamInStore(this.params).data;
            if (this.nullUser)
                data.push(this.company);
            return data;
        }
    }

}
</script>
